module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAVZJREFUaEPtmD1KA1EUhb9sINYxXdB9WCgGjIVCGpdhdmIWYSGIJP414kYUm+gGRFIEf3jhTfNwpph7XnTCnf5+Z+45j3mHadHwp9Xw98cX+OsEPQFPwOhAeoR2gFNgAJwb2erxE+AeGAO3BTxdYAZ01cpi3juwAXwHbrrAHdAXC6pxL0CvLIGw0FCtKOZNgXnZAmKt/Di/B/J7XK3gCXgCRgf8CBkNNI97AmYLjYC1S2AfGAF70ZhLo0Gq8eMIegTOgKuyLvQGdFSqmTgfsU5//lanJ8BhJmEV9gnYrmqj/32BG+DL67TqPFg5a/cZtRqy8nlPYOWWJ4KegCdgdMCPkNFA83iawG6s08X/0Quzgg4Qfnk+xDodSufySRd4BTZ1mllIoU63i0KXLnANHGSR1UGfga2qNnqk08pCCiYvvE5n8bYG1O+BGqZJRzwBqZ01YI1P4AdQ5yExf+rxxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ham.png
// module id = gSNM
// module chunks = 8